import { fetchPageData } from "./pageDataClient";
import type { PageStructureData } from "./globalSlotsQuery";

const localSlotsUrl = (label: string) => `/page-data/cms-structure?slots=local&label=${encodeURIComponent(label)}`;

/**
 * Fallback primitive for parallel page-data composition: resolves to null on ANY local-structure
 * failure (non-2xx, network, JSON-parse, or a 200 body without a slots array) so callers keep the
 * page initial-data envelope's slots untouched instead of breaking navigation (Q8i fallback).
 */
export async function fetchLocalSlots(label: string): Promise<PageStructureData | null> {
  try {
    const data = await fetchPageData<PageStructureData>(localSlotsUrl(label));
    return Array.isArray(data?.slots) ? data : null;
  } catch {
    return null;
  }
}
